import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// MUI imports
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";

// Redux
import { connect } from "react-redux"; // connect to the state
import { loginUser } from "../redux/actions/userActions";

const styles = (theme) => ({
  ...theme.spreadThis,
  paper: {
    padding: theme.spacing(2),
    marginTop: 0,
    marginBottom: 10,
    textAlign: "center",
    alignItems: "center",
    color: theme.palette.secondary,
    borderRadius: 15,
  },
});

class login extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      errors: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    // if we get any errors, set the prop state to the errors
    if (nextProps.UI.errors) {
      this.setState({ errors: nextProps.UI.errors });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const userData = {
      email: this.state.email,
      password: this.state.password,
    };
    this.props.loginUser(userData, this.props.history);
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  render() {
    const {
      classes,
      UI: { loadingCredentials },
    } = this.props;
    const { errors } = this.state;
    return (
      <Grid container className={classes.form}>
        <Grid item sm />
        <Grid item sm>
          <Paper className={classes.paper}>
            <Typography variant="h3" className={classes.pageTitle}>
              Login
            </Typography>

            <form noValidate onSubmit={this.handleSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                name="email"
                type="email"
                label="Email"
                className={classes.textField}
                helperText={errors.email}
                error={errors.email ? true : false}
                value={this.state.email}
                onChange={this.handleChange}
                fullWidth
                autoComplete="email"
                autoFocus
              />
              <TextField
                variant="outlined"
                margin="normal"
                id="password"
                name="password"
                type="password"
                label="Password"
                className={classes.textField}
                helperText={errors.password}
                error={errors.password ? true : false}
                value={this.state.password}
                onChange={this.handleChange}
                fullWidth
                autoComplete="current-password"
              />
              {errors.general && (
                <Typography variant="body2" className={classes.customError}>
                  {errors.general}
                </Typography>
              )}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                className={classes.button}
                disabled={loadingCredentials}
              >
                Login
                {loadingCredentials && (
                  <CircularProgress size={30} className={classes.progress} />
                )}
              </Button>
              <br />
              <Grid container>
                <Grid item xs>
                  <Button
                    color="inherit"
                    size="small"
                    component={Link}
                    to="/forgot_password"
                  >
                    Forgot password?
                  </Button>
                </Grid>
                <Grid item xs>
                  <Button
                    color="inherit"
                    component={Link}
                    size="small"
                    to="/signup"
                  >
                    Don't have an account?
                  </Button>
                </Grid>
              </Grid>
              <br />
            </form>
          </Paper>
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

login.propTypes = {
  classes: PropTypes.object.isRequired,
  loginUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
};

// takes the global state and returns what we need
const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

// telling which actions we will use
const mapActionsToProps = {
  loginUser,
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(login));
